import { IApprovalGroupFilters } from '../definitions/Approval'

export type PermissionType = 'allow' | 'disallow'

const PERMISSION_CATEGORIES = {
    'administrator': ['view', 'create', 'edit', 'delete', '*'],
    'claims': ['view', 'create', 'edit', 'delete', '*'],
    'claims-breakdown': ['view', 'create', 'edit', 'delete', '*'],
    'compare-contracts-csi': ['view', 'create', 'edit', 'delete', '*'],
    'contract-details': ['view', 'create', 'edit', 'delete', '*'],
    'contract-editor': ['view', 'create', 'edit', 'delete', '*'],
    'contract-schema': ['view', 'create', 'edit', 'delete', '*'],
    'contracts': ['view', 'create', 'edit', 'delete', '*'],
    'contracts-analysis': ['view', 'create', 'edit', 'delete', '*'],
    'contracts-manager': ['view', 'create', 'edit', 'delete', '*'],
    'flow': ['view', 'create', 'edit', 'delete', '*'],
    'flows': ['view', 'create', 'edit', 'delete', '*'],
    'fund': ['view', 'create', 'edit', 'delete', '*'],
    'funds': ['view', 'create', 'edit', 'delete', '*'],
    'funds-breakdown': ['view', 'create', 'edit', 'delete', '*'],
    'member-details': ['view', 'create', 'edit', 'delete', '*'],
    'members': ['view', 'create', 'edit', 'delete', '*'],
    'network': ['view', 'create', 'edit', 'delete', '*'],
    'overview': ['view', 'create', 'edit', 'delete', '*'],
    'playground': ['view', 'create', 'edit', 'delete', '*'],
    'provider': ['view', 'create', 'edit', 'delete', '*'],
    'provider-contracts': ['view', 'create', 'edit', 'delete', '*'],
    'provider-group': ['view', 'create', 'edit', 'delete', '*'],
    'provider-performance-breakdown': ['view', 'create', 'edit', 'delete', '*'],
    'quality-measures-breakdown': ['view', 'create', 'edit', 'delete', '*'],
    'role-editor': ['view', 'create', 'edit', 'delete', '*'],
    'settlement-details': ['view', 'create', 'edit', 'delete', '*'],
    'sign-in': ['view', 'create', 'edit', 'delete', '*'],
    'summary-exec-env-comparison': ['view'],
    'tcoc-summary': ['view', 'create', 'edit', 'delete', '*'],
    'tooltip-admin': ['view', 'create', 'edit', 'delete', '*'],
    'user-editor': ['view', 'create', 'edit', 'delete', '*'],
    'user-profile': ['view', 'create', 'edit', 'delete', '*'],
    'workflows': ['view', 'create', 'edit', 'delete', '*'],
    'approvals': ['view', 'create', 'edit', 'delete', '*'],
    'users-approvals': ['view', 'create', 'edit', 'delete', '*'],
    'user-management': ['view', 'create', 'edit', 'delete', '*'],
    'report-editor': ['view', 'create', 'edit', 'delete', '*'],
    'groups-management': ['view', 'create', 'edit', 'delete', '*'],
    'groups-editor': ['view', 'create', 'edit', 'delete', '*'],
    'approval-audit': ['view', 'create', 'edit', 'delete', '*'],
    'multirun-result': ['view', 'create', 'edit', 'delete', '*'],
    '*': ['*']
} as const

export const APPROVAL_CATEGORIES = {
    'approvals-contract': ['*'],
    'approvals-settlement': ['*'],
    'approvals-schema': ['*'],
    'approvals-flow': ['*']
} as const

export type Permission = `${keyof typeof PERMISSION_CATEGORIES}.${(typeof PERMISSION_CATEGORIES)[keyof typeof PERMISSION_CATEGORIES][number]}`

export const ENTITLEMENTS: Permission[] = Object.entries(PERMISSION_CATEGORIES)
    .flatMap(([category, actions]) => actions.map(action => `${category}.${action}` as Permission))

export const APPROVAL_ENTITLEMENTS: Permission[] = Object.entries(APPROVAL_CATEGORIES)
    .flatMap(([category, actions]) => actions.map(action => `${category}.${action}` as Permission))

export const CATEGORY_MAP: Record<IApprovalGroupFilters, keyof typeof APPROVAL_CATEGORIES> = {
    contracts: 'approvals-contract',
    settlements: 'approvals-settlement',
    schemas: 'approvals-schema',
    flows: 'approvals-flow'
}
export interface IRolesEntitlements {
    allow: string[]
    disallow: string[]
}
